import 'proto-polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import filters from './filters'
import 'amfe-flexible'
import { staticEvent } from '@/utils/tools'
import Vant from 'vant'
import 'vant/lib/index.less'
import '@vant/touch-emulator'
// import { getChannelCode } from '@/utils/utils.js'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import { initGuards } from './guard'

import 'swiper/dist/css/swiper.css'
import './assets/theme/vars.css'
import './assets/font/iconfont.css'

import {
  isInPZAPP,
  pzShareConfig
} from '@/utils/bridge'
import VConsole from 'vconsole'

if (process.env.NODE_ENV.includes('test')) {
  const vConsole = new VConsole()
  Vue.use(vConsole)
}

Vue.use(Vant)
Vue.use(VueAwesomeSwiper /* { default global options } */)
/**
 * 路由拦截器：调用之后
*/
router.beforeEach((to, from, next) => {
  if (isInPZAPP) {
    pzShareConfig({
      showShare: '0'
    })
  }
  const data = {}
  if (!to.query.channelCode && !!from.query.channelCode) {
    data.channelCode = from.query.channelCode
    next({
      name: to.name,
      query: {
        ...to.query,
        ...data,
        channelCode: from.query.channelCode
      }
    })
  } else {
    next()
    // const _channelCode = getChannelCode()
    // const canJumpMap = {
    //   '001098': 1,
    //   '099': 1
    // }
    // 放行的页面
    // const passBox = ['fundPositionDetail', 'Yiqianbao', 'InvestAdvisePositionDetail']
    // if (to.path.indexOf('/account/ocr') === 0 && !(passBox.includes(from.name))) {
    //   if (canJumpMap[_channelCode]) {
    //     next()
    //   } else {
    //     next({
    //       name: 'Notice'
    //     })
    //   }
    // } else {
    //   next()
    // }
    // if (to && to.name === 'AccountBindBank') {
    //   if (canJumpMap[_channelCode]) {
    //     next()
    //   } else {
    //     next({
    //       name: 'Notice'
    //     })
    //   }
    // } else {
    //   next()
    // }
  }
})
router.afterEach((to) => {
  if (to.meta.title) {
    document.title = to.meta.title
    var oFrame = document.createElement('iframe')
    oFrame.style.display = 'none'
    oFrame.onload = function () {
      setTimeout(() => {
        if (oFrame) {
          try {
            oFrame.parentNode.removeChild(oFrame)
          } catch (e) {}
        }
      }, 0)
    }
    document.body.appendChild(oFrame)
    oFrame.src = '/logo.png'
  }
})

for (const filterKey in filters) {
  Vue.filter(filterKey, filters[filterKey])
}

Vue.config.productionTip = false
Vue.prototype.$static = staticEvent

initGuards(router, store)

const app = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

app.$toast.setDefaultOptions('loading', {
  forbidClick: true,
  className: 'global-loading-image',
  icon: require('@/assets/images/yiqianbao/loading.png')
})
